import appGlobalScript from '/codebuild/output/src3280629793/src/src/global/app.ts';
export const globalScripts = appGlobalScript;
